// extracted by mini-css-extract-plugin
module.exports = {"input":"inputs_input__1vw-d","textarea":"inputs_textarea__3juOM","error":"inputs_error__1K7ID","select":"inputs_select__1lRCf"};